import { useEffect, useState } from 'react';

type scriptTypes = 'text/javascript' | 'text/css';
type scriptLoadOptions = 'defer' | 'async' | null;

export const useExternalScript = (
  url: string,
  scriptType: scriptTypes,
  scriptLoadOption: scriptLoadOptions = null,
) => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const head = document.querySelector('head');
    if (!head) return;
    const elementTag = scriptType === 'text/css' ? 'link' : 'script';
    const element = document.createElement(elementTag);
    if (scriptType === 'text/css') {
      element.setAttribute('href', url);
      element.setAttribute('rel', 'stylesheet');
    } else {
      element.setAttribute('src', url);
      scriptLoadOption && element.setAttribute(scriptLoadOption, 'true');
    }
    element.setAttribute('type', scriptType);
    head.appendChild(element);
    setIsLoaded(true);
    return () => {
      head.removeChild(element);
    };
  }, [url]);

  return isLoaded;
};
